export function GetFieldId(fieldName) {
  return fieldName.replaceAll(" ", "");
}
